import { render, staticRenderFns } from "./ResultCompo.vue?vue&type=template&id=4e99c00f&scoped=true&"
import script from "./ResultCompo.vue?vue&type=script&lang=js&"
export * from "./ResultCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e99c00f",
  null
  
)

export default component.exports